import { motion } from "framer-motion";

export const Manifesto = () => {
    const words = "Transformamos ideias, marcas e negócios em materiais que aparecem.".split(" ");
    return (
        <section id="sobre" data-testid="manifesto-section" className="grain relative bg-ink py-24 sm:py-32 lg:py-40 text-white">
            <div className="container-x">
                <p className="section-tag flex items-center gap-3">
                    <span className="inline-block h-px w-8 bg-brand" />
                    00 — Quem somos
                </p>
                <h2 className="mt-8 max-w-5xl font-display text-3xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.08] tracking-tight">
                    {words.map((w, i) => (
                        <motion.span
                            key={i}
                            initial={{ opacity: 0.12 }}
                            whileInView={{ opacity: 1 }}
                            viewport={{ once: true, margin: "-30%" }}
                            transition={{ duration: 0.5, delay: i * 0.045 }}
                            className={`inline-block mr-[0.28em] ${["materiais", "aparecem."].includes(w) ? "text-brand" : ""}`}
                        >
                            {w}
                        </motion.span>
                    ))}
                </h2>
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    className="mt-10 max-w-2xl text-base sm:text-lg leading-relaxed text-mist"
                >
                    A IMPRIMA AKI atende empresas, comércios e profissionais de Campinas e região com produção gráfica,
                    comunicação visual e personalização — do cartão de visita à fachada completa do seu ponto comercial.
                </motion.p>
            </div>
        </section>
    );
};
